import { render, staticRenderFns } from "./MidiExplained.vue?vue&type=template&id=3d6b1254&scoped=true&"
import script from "./MidiExplained.vue?vue&type=script&lang=js&"
export * from "./MidiExplained.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b1254",
  null
  
)

export default component.exports